<svg class="icon-context max-width-init" [class.active]="isActive" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
    viewBox="0 0 16 16" fill="none">
    <path
        d="M11.5 14.5V1.5M11.5 14.5C11.5 15.0523 11.9477 15.5 12.5 15.5H15M11.5 14.5C11.5 15.0523 11.0523 15.5 10.5 15.5H8M11.5 1.5C11.5 0.947716 11.9477 0.5 12.5 0.5H15M11.5 1.5C11.5 0.947716 11.0523 0.5 10.5 0.5H8"
        stroke="var(--text-color-dark)" />
    <path d="M1.5 5C1.5 4.17157 2.17157 3.5 3 3.5H11.5V12.5H3C2.17157 12.5 1.5 11.8284 1.5 11V5Z"
        stroke="var(--text-color-dark)" />
</svg>
